import React, { useState, useEffect } from "react";
import "./alert.css";
import {
  Drawer,
  Grid,
  Button,
  InputLabel,
  TextField,
  Typography,
  Alert,
} from "@mui/material";
import instance from "../../ApiInstance/Inetrceptor";
import CancelIcon from "@mui/icons-material/Cancel";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import CustomTheme from "../../Customtheme/Themes"

const HandlingAddtracks = ({
  isDrawerOpen,
  setIsDrawerOpen,
  isEditSectionOpen,
  isAddSectionOpen,
  handlinginfo,
  GetHandlingData,
}) => {
  const { drawerWidth, isXs, isSm, isMd, isLg, isXl } = CustomTheme();
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [backDrop, setBackDrop] = useState(false);
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [phoneNumberValue, setPhoneNumberValue] = useState("");
  const [phoneNumberError1, setPhoneNumberError1] = useState("");
  const [phoneNumberValue1, setPhoneNumberValue1] = useState("");
  const [phoneNumberError2, setPhoneNumberError2] = useState("");
  const [phoneNumberValue2, setPhoneNumberValue2] = useState("");
  const [addnew, setAddnew] = useState({
    alert_handling_track_id: 0,
    alert_handling_track_name: "",
    alert_handling_track_desc: "",
    notification_interval: "",
    escalation_00_emails: "",
    escalation_00_sms: phoneNumberValue,
    escalation_01_emails: "",
    escalation_01_sms: phoneNumberValue1,
    escalation_02_emails: "",
    escalation_02_sms: phoneNumberValue2,
  });
  const [information, setInformation] = useState({});
  const handleChangeedit = (event) => {
    const { id, value } = event.target;
    const sanitizedValue =
      id === "notification_interval" ? value.replace(/[^0-9]/g, "") : value;
    setInformation((prevData) => ({
      ...prevData,
      [id]: sanitizedValue,
    }));
  };
  const handlePhoneChange = (value) => {
    setPhoneNumberValue(value);
    if (value && !isValidPhoneNumber(value)) {
      setPhoneNumberError("Invalid phone number");
    } else {
      setPhoneNumberError("");
    }
  };
  const handlePhoneChange1 = (value) => {
    setPhoneNumberValue1(value);
    if (value && !isValidPhoneNumber(value)) {
      setPhoneNumberError1("Invalid phone number");
    } else {
      setPhoneNumberError1("");
    }
  };
  const handlePhoneChange2 = (value) => {
    setPhoneNumberValue2(value);
    console.log("value", value);
    if (value && !isValidPhoneNumber(value)) {
      setPhoneNumberError2("Invalid phone number");
    } else {
      setPhoneNumberError2("");
    }
  };
  const handlePhoneChangeEdit = (value, type) => {
    if (type === 1) {
      setPhoneNumberValue(value);
      if (value && !isValidPhoneNumber(value)) {
        setPhoneNumberError("Invalid phone number");
      } else {
        setPhoneNumberError("");
      }
    } else if (type === 2) {
      setPhoneNumberValue1(value);
      if (value && !isValidPhoneNumber(value)) {
        setPhoneNumberError1("Invalid phone number");
      } else {
        setPhoneNumberError1("");
      }
    } else if (type === 3) {
      setPhoneNumberValue2(value);
      if (value && !isValidPhoneNumber(value)) {
        setPhoneNumberError2("Invalid phone number");
      } else {
        setPhoneNumberError2("");
      }
    }
  };
  const handleinputChange = (event) => {
    const { id, value } = event.target;
    const sanitizedValue =
    id === "notification_interval" ? value.replace(/[^0-9]/g, "").slice(0, 5) : value;
    setAddnew((prevData) => ({
      ...prevData,
      [id]: sanitizedValue,
    }));
  };
  const handleCloseErrorcode = () => {
    setError("");
  };
  const handleDrawerClose = (event) => {
    // if (event.target.id === "back-button") {
    setIsDrawerOpen(false);
    // }
  };
  const handleAddNewClick = (event) => {
    event.stopPropagation();
    setIsDrawerOpen(true);
    const handlename = addnew.alert_handling_track_name.trim();
    const handleIntr = String(addnew.notification_interval).trim();
    const handleEmail01 = addnew.escalation_00_emails.trim();
    const handleEmail02 = addnew.escalation_01_emails.trim();
    const handleEmail03 = addnew.escalation_02_emails.trim();

    if (!handlename || !handleIntr || !handleEmail01) {
      setError("Please enter all the fields mandatory.");
      setTimeout(() => {
        handleCloseErrorcode();
      }, 5000);
    } else {
      const emailFields = [
        "escalation_00_emails",
        "escalation_01_emails",
        "escalation_02_emails",
      ];

      let invalidEmails = [];

      emailFields.forEach((field) => {
        const fieldValue = addnew[field].trim();

        if (fieldValue !== "") {
          // const emailArray = fieldValue.split(",").map((email) => email.trim());
          const emailArray = fieldValue
            .split(/[,]+/)
            .map((email) => email.trim());
          console.log("emailArray", emailArray);

          emailArray.forEach((email) => {
            if (!validateEmail(email)) {
              invalidEmails.push(
                `Email '${email}' in field '${field}' is invalid.`
              );
            }
          });
        }
      });

      if (invalidEmails.length > 0) {
        setError(invalidEmails.join(" "));
        setTimeout(() => {
          setError("");
        }, 5000);
      } else {
        setBackDrop(true);
        const body = {
          alert_handling_track_id: 0,
          alert_handling_track_name: addnew.alert_handling_track_name,
          alert_handling_track_desc: addnew.alert_handling_track_desc,
          notification_interval: addnew.notification_interval,
          escalation_00_emails: addnew.escalation_00_emails,
          escalation_00_sms: phoneNumberValue,
          escalation_01_emails: addnew.escalation_01_emails,
          escalation_01_sms: phoneNumberValue1,
          escalation_02_emails: addnew.escalation_02_emails,
          escalation_02_sms: phoneNumberValue2,
        };
        instance
          .post("api/v1/Master/AlertHandlingTrack/Post", body)
          .then((res) => {
            console.log("resp", res);
            if (res?.data?.Success) {
              setError("");
              setSuccess(res?.data?.ResultMessage);
              GetHandlingData(1);
              setTimeout(() => {
                setSuccess(null);
              }, 5000);
            } else {
              setError(res?.data?.ResultMessage);
              setTimeout(() => {
                setError(null);
              }, 5000);
            }
            setAddnew({
              alert_handling_track_id: 0,
              alert_handling_track_name: "",
              alert_handling_track_desc: "",
              notification_interval: "",
              escalation_00_emails: "",
              escalation_01_emails: "",
              escalation_02_emails: "",
            });
            setPhoneNumberValue("");
            setPhoneNumberValue1("");
            setPhoneNumberValue2("");
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setBackDrop(false);
          });
      }
    }
  };
  const validateEmail = (email) => {
    const emailArray = email.split(/[,]+/).map((e) => e.trim());

    for (const e of emailArray) {
      const emailRegex =
        /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)$/i;
      if (!emailRegex.test(e)) {
        return false;
      }
    }

    return true;
  };
  const handleEditClick = (event) => {
    event.stopPropagation();
    setIsDrawerOpen(true);
    const handlename = information?.alert_handling_track_name?.trim();
    const handleIntr = String(information?.notification_interval)?.trim();
    const handleEmail01 = information?.escalation_00_emails?.trim();
    const handleEmail02 = information?.escalation_01_emails?.trim();
    const handleEmail03 = information?.escalation_02_emails?.trim();

    if (!handlename || !handleIntr || !handleEmail01) {
      setError("Please enter all the fields mandatory.");
      setTimeout(() => {
        handleCloseErrorcode();
      }, 5000);
    } else {
      const emailFields = [
        "escalation_00_emails",
        "escalation_01_emails",
        "escalation_02_emails",
      ];
      let invalidEmails = [];

      emailFields.forEach((field) => {
        const fieldValue = information[field].trim();

        if (fieldValue !== "") {
          const emailArray = fieldValue
            .split(/[,]+/)
            .map((email) => email.trim());

          emailArray.forEach((email) => {
            if (!validateEmail(email)) {
              invalidEmails.push(
                `Email '${email}' in field '${field}' is invalid.`
              );
            }
          });
        }
      });

      if (invalidEmails.length > 0) {
        setError(invalidEmails.join(" "));
        setTimeout(() => {
          setError("");
        }, 5000);
      } else {
        setBackDrop(true);
        const body = {
          alert_handling_track_id: information.alert_handling_track_id,
          alert_handling_track_name: information.alert_handling_track_name,
          alert_handling_track_desc: information.alert_handling_track_desc,
          notification_interval: information.notification_interval,
          escalation_00_emails: information.escalation_00_emails,
          escalation_00_sms: phoneNumberValue,
          escalation_01_emails: information.escalation_01_emails,
          escalation_01_sms: phoneNumberValue1,
          escalation_02_emails: information.escalation_02_emails,
          escalation_02_sms: phoneNumberValue2,
        };
        instance
          .post("api/v1/Master/AlertHandlingTrack/Post", body)
          .then((res) => {
            if (res?.data?.Success) {
              setError("");
              setSuccess(res?.data?.ResultMessage);
              GetHandlingData(1);
              setTimeout(() => {
                setSuccess(null);
              }, 5000);
            } else {
              setError(res?.data?.ResultMessage);
              setTimeout(() => {
                setError(null);
              }, 5000);
            }
          })

          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setBackDrop(false);
          });
      }
    }
  };
  useEffect(() => {
    setInformation(handlinginfo);
  }, [handlinginfo]);
  return (
    <>
      <Drawer
        anchor="right"
        open={isDrawerOpen}
        PaperProps={{
          sx: {
            width: drawerWidth, 
          },
        }}
      >
        <div
          style={{ padding: "20px" }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Button
                id="back-button"
                variant="contained"
                color="transparent"
                className="button_backAlert"
                onClick={handleDrawerClose}
                startIcon={<ArrowBackIcon onClose={handleDrawerClose} />}
              >
                Back
              </Button>
            </Grid>
            {/* /////////.......for Add New Data..//////////////// */}
            {isAddSectionOpen && (
              <>
                <Grid item xs={12}>
                  <Typography
                    variant="h5"
                    className="font-colorAlert mb-0"
                    style={{ fontWeight: "600" }}
                  >
                    Add Alert Handling Track{" "}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="h7"
                    className="font-colorAlert mb-1"
                    style={{ fontWeight: "600" }}
                  >
                    Alert Handling Track Information{" "}
                  </Typography>
                </Grid>
                {error && (
                  <Alert
                    variant="outlined"
                    severity="error"
                    icon={<CancelIcon onClick={handleCloseErrorcode} />}
                    className="errorAlert mt-4"
                  >
                    {error}
                  </Alert>
                )}
                {success && (
                  <Alert
                    variant="outlined"
                    severity="success"
                    className="sucessAlert mt-4"
                  >
                    {success}
                  </Alert>
                )}
                <Grid item xs={12}>
                  <InputLabel htmlFor="alert_handling_track_name">
                    Handling Track Name<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <TextField
                    id="alert_handling_track_name"
                    size="small"
                    variant="outlined"
                    value={addnew.alert_handling_track_name}
                    onChange={(event) => handleinputChange(event)}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputLabel htmlFor="alert_handling_track_desc">
                    Description
                  </InputLabel>
                  <TextField
                    id="alert_handling_track_desc"
                    size="small"
                    multiline
                    rows={4}
                    variant="outlined"
                    value={addnew.alert_handling_track_desc}
                    onChange={(event) => handleinputChange(event)}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputLabel htmlFor="notification_interval">
                    Interval In Seconds<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <TextField
                    id="notification_interval"
                    size="small"
                    variant="outlined"
                    value={addnew.notification_interval}
                    onChange={(event) => handleinputChange(event)}
                    fullWidth
                    inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="h7"
                    className="font-colorAlert"
                    style={{ fontWeight: "600" }}
                  >
                    Escalation 0
                  </Typography>
                </Grid>
                <Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
                  <InputLabel htmlFor="escalation_00_emails">
                    E-Mail<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <TextField
                    type="Email"
                    id="escalation_00_emails"
                    size="small"
                    variant="outlined"
                    fullWidth
                    value={addnew.escalation_00_emails}
                    onChange={(event) => handleinputChange(event)}
                  />
                </Grid>
                <Grid item xs={5} sm={5} md={5} lg={5} xl={5}>
                  <InputLabel htmlFor="escalation_00_sms">SMS</InputLabel>
                  <div className="phone-input-div">
                    <PhoneInput
                      placeholder="Enter phone number"
                      international
                      countryCallingCodeEditable={false}
                      defaultCountry="IN"
                      value={addnew.escalation_00_sms}
                      onChange={handlePhoneChange}
                      error={phoneNumberError}
                      className="custom-phone-input"
                    />
                  </div>
                  {phoneNumberError && (
                    <div style={{ color: "red" }}>{phoneNumberError}</div>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="h7"
                    className="font-colorAlert"
                    style={{ fontWeight: "600" }}
                  >
                    Escalation 1
                  </Typography>
                </Grid>
                <Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
                  <InputLabel htmlFor="escalation_01_emails">E-Mail</InputLabel>
                  <TextField
                    type="Email"
                    id="escalation_01_emails"
                    size="small"
                    value={addnew.escalation_01_emails}
                    onChange={(event) => handleinputChange(event)}
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={5} sm={5} md={5} lg={5} xl={5}>
                  <InputLabel htmlFor="escalation_01_sms">SMS</InputLabel>
                  <div className="phone-input-div">
                    <PhoneInput
                      placeholder="Enter phone number"
                      international
                      countryCallingCodeEditable={false}
                      defaultCountry="IN"
                      value={addnew.escalation_01_sms}
                      onChange={handlePhoneChange1}
                      error={phoneNumberError1}
                      className="custom-phone-input"
                    />
                  </div>
                  {phoneNumberError1 && (
                    <div style={{ color: "red" }}>{phoneNumberError1}</div>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="h7"
                    className="font-colorAlert"
                    style={{ fontWeight: "600" }}
                  >
                    Escalation 2
                  </Typography>
                </Grid>
                <Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
                  <InputLabel htmlFor="escalation_02_emails">E-Mail</InputLabel>
                  <TextField
                    type="Email"
                    id="escalation_02_emails"
                    size="small"
                    value={addnew.escalation_02_emails}
                    onChange={(event) => handleinputChange(event)}
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={5} sm={5} md={5} lg={5} xl={5}>
                  <InputLabel htmlFor="escalation_02_sms">SMS</InputLabel>
                  <div className="phone-input-div">
                    <PhoneInput
                      placeholder="Enter phone number"
                      international
                      countryCallingCodeEditable={false}
                      defaultCountry="IN"
                      value={phoneNumberValue2}
                      onChange={handlePhoneChange2}
                      error={phoneNumberError2}
                      className="custom-phone-input"
                    />
                  </div>
                  {phoneNumberError2 && (
                    <div style={{ color: "red" }}>{phoneNumberError2}</div>
                  )}
                </Grid>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  className="mt-4"
                >
                  <Grid item xs={10}>
                    <p style={{color:"var(--color-secondary",paddingLeft: "1rem"}}>Note-: Multiple emails can be entered with comma(,) seperator.</p>
                  </Grid>
                  <Grid item xs={2} sx={{ textAlign: "right" }}>
                    <Button
                      id="back-button"
                      variant="contained"
                      color="secondary"
                      onClick={(event) => handleAddNewClick(event)}
                    >
                      Create
                    </Button>
                  </Grid>
                </Grid>
              </>
            )}
            {/* //....for edit..//////////// */}
            {isEditSectionOpen && (
              <>
                <Grid item xs={12}>
                  <Typography
                    variant="h5"
                    className="font-colorAlert mb-0"
                    style={{ fontWeight: "600" }}
                  >
                    Edit Alert Handling Track{" "}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="h7"
                    className="font-colorAlert mb-1"
                    style={{ fontWeight: "600" }}
                  >
                    Alert Handling Track Information{" "}
                  </Typography>
                </Grid>
                {error && (
                  <Alert
                    variant="outlined"
                    severity="error"
                    icon={<CancelIcon />}
                    className="errorAlert mt-4"
                  >
                    {error}
                  </Alert>
                )}
                {success && (
                  <Alert
                    variant="outlined"
                    severity="success"
                    className="sucessAlert mt-4"
                  >
                    {success}
                  </Alert>
                )}
                <Grid item xs={12}>
                  <InputLabel htmlFor="alert_handling_track_name">
                    Handling Track Name<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <TextField
                    id="alert_handling_track_name"
                    size="small"
                    variant="outlined"
                    value={information.alert_handling_track_name}
                    onChange={(event) => handleChangeedit(event)}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputLabel htmlFor="alert_handling_track_desc">
                    Description
                  </InputLabel>
                  <TextField
                    id="alert_handling_track_desc"
                    size="small"
                    multiline
                    rows={4}
                    variant="outlined"
                    value={information.alert_handling_track_desc}
                    onChange={(event) => handleChangeedit(event)}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputLabel htmlFor="notification_interval">
                    Interval In Seconds<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <TextField
                    id="notification_interval"
                    size="small"
                    variant="outlined"
                    value={information.notification_interval}
                    onChange={(event) => handleChangeedit(event)}
                    fullWidth
                    inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="h7"
                    className="font-colorAlert"
                    style={{ fontWeight: "600" }}
                  >
                    Escalation 0
                  </Typography>
                </Grid>
                <Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
                  <InputLabel htmlFor="escalation_00_emails">
                    E-Mail<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <TextField
                    type="Email"
                    id="escalation_00_emails"
                    size="small"
                    variant="outlined"
                    fullWidth
                    value={information.escalation_00_emails}
                    onChange={(event) => handleChangeedit(event)}
                  />
                </Grid>
                <Grid item xs={5} sm={5} md={5} lg={5} xl={5}>
                  <InputLabel htmlFor="escalation_00_sms">SMS</InputLabel>
                  <div className="phone-input-div">
                    <PhoneInput
                      placeholder="Enter phone number"
                      international
                      countryCallingCodeEditable={false}
                      defaultCountry="IN"
                      value={information.escalation_00_sms}
                      onChange={(value) => handlePhoneChangeEdit(value, 1)}
                      error={phoneNumberError}
                      className="custom-phone-input"
                    />
                  </div>
                  {phoneNumberError && (
                    <div style={{ color: "red" }}>{phoneNumberError}</div>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="h7"
                    className="font-colorAlert"
                    style={{ fontWeight: "600" }}
                  >
                    Escalation 1
                  </Typography>
                </Grid>
                <Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
                  <InputLabel htmlFor="escalation_01_emails">E-Mail</InputLabel>
                  <TextField
                    type="Email"
                    id="escalation_01_emails"
                    size="small"
                    value={information.escalation_01_emails}
                    onChange={(event) => handleChangeedit(event)}
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={5} sm={5} md={5} lg={5} xl={5}>
                  <InputLabel htmlFor="escalation_01_sms">SMS</InputLabel>
                  <div className="phone-input-div">
                    <PhoneInput
                      placeholder="Enter phone number"
                      international
                      countryCallingCodeEditable={false}
                      defaultCountry="IN"
                      value={information.escalation_01_sms}
                      onChange={(value) => handlePhoneChangeEdit(value, 2)}
                      error={phoneNumberError1}
                      className="custom-phone-input"
                    />
                  </div>
                  {phoneNumberError1 && (
                    <div style={{ color: "red" }}>{phoneNumberError1}</div>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="h7"
                    className="font-colorAlert"
                    style={{ fontWeight: "600" }}
                  >
                    Escalation 2
                  </Typography>
                </Grid>
                <Grid item xs={7} sm={7} md={7} lg={7} xl={7}>
                  <InputLabel htmlFor="escalation_02_emails">E-Mail</InputLabel>
                  <TextField
                    type="Email"
                    id="escalation_02_emails"
                    size="small"
                    value={information.escalation_02_emails}
                    onChange={(event) => handleChangeedit(event)}
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={5} sm={5} md={5} lg={5} xl={5}>
                  <InputLabel htmlFor="escalation_02_sms">SMS</InputLabel>
                  <div className="phone-input-div">
                    <PhoneInput
                      placeholder="Enter phone number"
                      international
                      countryCallingCodeEditable={false}
                      defaultCountry="IN"
                      value={information.escalation_02_sms}
                      onChange={(value) => handlePhoneChangeEdit(value, 3)}
                      error={phoneNumberError2}
                      className="custom-phone-input"
                    />
                  </div>
                  {phoneNumberError2 && (
                    <div style={{ color: "red" }}>{phoneNumberError2}</div>
                  )}
                </Grid>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  className="mt-4"
                >
                  <Grid item xs={9}>
                    <p style={{color:"var(--color-secondary",paddingLeft: "1rem"}}>Note-: Multiple emails can be entered with comma(,) seperator.</p>
                  </Grid>
                  <Grid item xs={3} sx={{ textAlign: "right" }}>
                  <Button
                    id="back-button"
                    variant="contained"
                    color="secondary"
                    onClick={(event) => handleEditClick(event)}
                  >
                    Save Changes
                  </Button>
                  </Grid>
                </Grid>
              </>
            )}
          </Grid>
        </div>
      </Drawer>
    </>
  );
};

export default HandlingAddtracks;
